import { getStation } from '@/utils/requestHandler.js'
import { getWebcam } from '@/utils/requestHandler'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'

export default {
   name: 'Address',
   components: {
      LoadingSpinner,
      BadRequest
   },
   data() {
      return {
         station: null,
         webcam: null,
         degrees: '',
         latCardinal: null,
         lngCardinal: null,
         isLightBoxVisible: false,
         index: 0,
         loading: true,
         error: null
      }
   },
   async created() {
      this.station = await getStation(this.$route.params.code)
      if (typeof this.station == 'string') {
         if (this.station.includes('Request failed') || this.station.toLowerCase().includes('error')) {
            this.error = this.station
            console.log(this.error)
            this.loading = false
         }
      } else {
         this.degrees = this.convertDMS()

         if (this.$route.name === 'Address') {
            this.webcam = await getWebcam(this.$route.params.code)
            if (typeof this.webcam == 'string') {
               if (this.webcam.includes('Request failed') || this.webcam.toLowerCase().includes('error')) {
                  this.error = this.webcam
                  console.log(this.error)
                  this.loading = false
               }
            }
         }
      }
      this.loading = false
   },
   methods: {
      convertDMS() {
         let lat = this.station.coordinates.wgsCoordinate.latitude
         let lng = this.station.coordinates.wgsCoordinate.longitude
         const height = this.station.coordinates.wgsCoordinate.height

         let convertLat = Math.abs(lat)
         let latDeg = Math.floor(convertLat)
         let latMin = Math.floor((convertLat - latDeg) * 60)
         let latSec = Math.round((convertLat - latDeg - latMin / 60) * Math.pow(60, 2) * 100) / 100
         this.latCardinal = lat > 0 ? 'N' : 'S'

         let convertLng = Math.abs(lng)
         let lngDeg = Math.floor(convertLng)
         let lngMin = Math.floor((convertLng - lngDeg) * 60)
         let lngSec = Math.round((convertLng - lngDeg - lngMin / 60) * Math.pow(60, 2) * 100) / 100
         this.lngCardinal = lng > 0 ? 'E' : 'W'

         return (
            latDeg +
            '° ' +
            latMin +
            "' " +
            latSec +
            "'' " +
            this.latCardinal +
            '; ' +
            lngDeg +
            '° ' +
            lngMin +
            "' " +
            lngSec +
            "'' " +
            this.lngCardinal +
            '; ' +
            height +
            'H'
         )
      }
   }
}
